import { apiClient } from "../api"
import { DTO_LiveCams, DTO_RoadConditions, DTO_Weather } from "./types/maps"

enum Map {
  ROAD_CONDITIONS = '/roadcondition/',
  WEATHER = '/system/vegagerdin_proxy/weather/',
  LIVE_CAMS = '/system/vegagerdin_proxy/livecams/'
}

export const getRoadConditions = (): Promise<DTO_RoadConditions> => {
  const ac = apiClient()
  const promise = ac.get(Map.ROAD_CONDITIONS)
    .then(res => res.data)
  return promise
}

export const getWeather = (): Promise<DTO_Weather[]> => {
  const ac = apiClient()
  const promise = ac.get(Map.WEATHER)
    .then(res => res.data)
  return promise
}

export const getLiveCams = (): Promise<DTO_LiveCams[]> => {
  const ac = apiClient()
  const promise = ac.get(Map.LIVE_CAMS)
    .then(res => res.data)
  return promise
}
